import Alert from '@cloudscape-design/components/alert';
import Box from '@cloudscape-design/components/box';
import Button from '@cloudscape-design/components/button';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State {
  err: Error | null;
}

/**
 * Wraps each section route in an error boundary so a single section crash
 * doesn't take down the whole shell.
 */
export class SectionSlot extends Component<{ children: ReactNode }, State> {
  override state: State = { err: null };

  static getDerivedStateFromError(err: Error): State {
    return { err };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[SectionSlot] error in mounted section', error, info);
  }

  override render(): ReactNode {
    if (this.state.err) {
      return (
        <Box padding="l">
          <Alert
            type="error"
            header="This section failed to render"
            action={<Button onClick={() => this.setState({ err: null })}>Retry</Button>}
          >
            <SpaceBetween size="xs">
              <Box variant="strong">{this.state.err.message}</Box>
              {this.state.err.stack ? (
                <Box variant="code" fontSize="body-s">
                  <pre style={{ margin: 0 }}>{this.state.err.stack.slice(0, 800)}</pre>
                </Box>
              ) : null}
            </SpaceBetween>
          </Alert>
        </Box>
      );
    }
    return this.props.children;
  }
}
